/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, {css} from "styled-components";
import Colors from "constants/Colors";
import PropTypes from "prop-types";
import {FontWeight, QuicksandBold} from "components/Text";
import {FiraSansBold, FiraSansExtraLight} from "components/Text/Text";
import {Breakpoints} from "../../../../constants/Breakpoints";

const propTypes = {
  isActive: PropTypes.bool,
  newBorder: PropTypes.bool,
};

const defaultProps = {
  isActive: false,
  newBorder: false,
};

const ButtonContainer = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items:center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 20px 0px 0px;
`;


const ButtonContent = styled.div`
  display:flex;
  flex-direction:auto;
  justify-content:space-evenly;
  background-color:#FFF;  
`;

const CalendarContainer = styled.div`
  z-index: 55;
  top: 60px;
  right: 24px;

  position: absolute;
`;

const BorderSwitch = styled.div`
  background: ${Colors.GRAY[6]};
  padding-left: 1px;
  border-radius: 14px;
  width: 57px;
  padding-top: 1px;
  padding-right: 1px;
  height: 30px;
  display: -webkit-inline-box;
  margin-left: 5px;

  ${({newBorder}) =>
  newBorder
    ? css`
          margin-top: 10px;
        `
    : ""}
`;

const TextArea = styled.textarea`
  width: 102%;
  height: 70px;
  border: 1px solid #888;
  border-radius: 8px;
  margin-left: -12px;
  margin-top: 0px;
  padding: 10px;
  margin-bottom: 0px;
  resize: none;
  cursor: auto;
  ${FiraSansBold};  
  color: ${Colors.GRAY[0]};
  transition: box-shadow 0.15s ease;

  outline: none;
  :focus {
    background: ${Colors.GRAY[5]}
    box-shadow: inset 0px 2px 6px rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 0 3px ${Colors.SECONDARY};
  }
`;

export const AddButton = styled.button`
  display: flex;
  width: 50px;
  height: 50px;
  border: 0px;
  background-color: transparent;
  cursor: pointer;
`;
export const SelectField = styled.select`
  width: 100%;
  position: relative;
  height: 42px;
  padding: 8px;
  border: solid 1px ${Colors.GRAY[3]};
  border-radius: 8px;
  background: white;
  font-size: 16px;
  color: ${Colors.GRAY[1]};
  outline: none;
  align-self: auto;
  box-sizing: border-box;
  text-align: initial;
  margin-bottom: 20px;
  ${FiraSansBold}

  transition: background 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: ${Colors.GRAY[3]};
  }

  &[disabled] {
    background-color: ${Colors.GRAY[4]};
    color: ${Colors.GRAY[0]};
  }
`;

const LayoutCircle = styled.div`
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
  text-align: center;

  align-self: center;

  ${({isActive}) =>
  isActive
    ? css`
      border: 1px solid ${Colors.GRAY[5]};
      background-color: ${Colors.BLUE};
      color: ${Colors.WHITE}
      box-shadow: 0px 3px 4px -2px rgba(0,0,0,0.75);
    `
    : ` border: 1px solid ${Colors.BLUE};
      background-color: ${Colors.WHITE};
      color: ${Colors.BLACK};
    `}
`;

const Scrollbox = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: 550px;
  padding: 10px 20px 10px 10px;

  ::-webkit-scrollbar {
    background: ${Colors.WHITE};
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }
`;

const CircleBox = styled.div`
  margin-right: 10%;
  display: block;
  margin-top: 20px;
  
  @media screen and (min-width: ${Breakpoints.md}) {
    display: inline;
  }
`;

const TagInput = styled.input`
  flex: 1;
  display: none;
  border: none;
  width: 100%;

  &:focus {
    outline: transparent;
  }
`;

const PlaceHolder = styled.label`
  display: block;
  padding: 0.75rem 3.75rem;
  text-transform: uppercase;
  -webkit-letter-spacing: -0.5px;
  -moz-letter-spacing: -0.5px;
  -ms-letter-spacing: -0.5px;
  letter-spacing: -0.5px;
  font-size: 16px;
  height: 42px;
  width: auto;
  white-space: nowrap;
  font-family: "Quicksand";
  font-weight: bold;
  font-style: normal;
  border: 0 none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  -webkit-transition: background-color 0.15s ease, color 0.15s ease,
    width 0.3s ease, border 0.5s ease, border-color 0.5s ease,
    box-shadow 0.15s ease;
  transition: background-color 0.15s ease, color 0.15s ease, width 0.3s ease,
    border 0.5s ease, border-color 0.5s ease, box-shadow 0.15s ease;
  text-align: center;
  color: #ffffff;
  background-color: ${Colors.BLUE};
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
`;

/* &::disabled {
  background-color: ${Colors.GRAY[4]};
  color: ${Colors.GRAY[0]};
} */

export {
  ButtonContainer,
  TextArea,
  LayoutCircle,
  Scrollbox,
  CircleBox,
  BorderSwitch,
  CalendarContainer,
  PlaceHolder,
  TagInput,
  ButtonContent,
};
